import {EditGuesser, ListGuesser, ShowGuesser} from "react-admin";

import MenuBookIcon from '@mui/icons-material/MenuBook';

const EntityResourceProps = {
    name: "entity",
    list: ListGuesser,
    edit: EditGuesser,
    show: ShowGuesser,
};

export const EntityMenuProps = {
    to: "/entity",
    primaryText: "Organisation",
    icon: MenuBookIcon,
};

export default EntityResourceProps;
